import axios from 'axios';
import { apiBase } from '@/constants';

export default {
  state: {
    accountSettings: {
      actionsPerDay: 0,
      likesPerDay: 0,
      followsPerDay: 0,
      unfollowsPerDay: 0,
      minIntervalMilliseconds: 0,
      maxIntervalMilliseconds: 0
    },
    settingsLoaded: false
  },
  getters: {
    actionsLimit(state) {
      return state.accountSettings.actionsPerDay;
    },
    followsLimit(state) {
      return state.accountSettings.followsPerDay;
    },
    likesLimit(state) {
      return state.accountSettings.likesPerDay;
    },
    settingsLoaded(state) {
      return state.settingsLoaded;
    },
    unfollowsLimit(state) {
      return state.accountSettings.unfollowsPerDay;
    },
    minIntervalMilliseconds(state) {
      return state.accountSettings.minIntervalMilliseconds;
    },
    maxIntervalMilliseconds(state) {
      return state.accountSettings.maxIntervalMilliseconds;
    }
  },
  mutations: {
    getCurrentAccountsSettings(state, settings) {
      state.accountSettings = settings;
    },
    setActionsLimit(state, value) {
      state.accountSettings.actionsPerDay = value;
    },
    setFollowsLimit(state, value) {
      state.accountSettings.followsPerDay = value;
    },
    setLikesLimit(state, value) {
      state.accountSettings.likesPerDay = value;
    },
    setSettingsLoaded(state, value) {
      state.settingsLoaded = value;
    },
    setUnfollowsLimit(state, value) {
      state.accountSettings.unfollowsPerDay = value;
    },
    setMinIntervalMilliseconds(state, value) {
      state.accountSettings.minIntervalMilliseconds = value;
    },
    setMaxIntervalMilliseconds(state, value) {
      state.accountSettings.maxIntervalMilliseconds = value;
    },
    updateCurrentAccountsSettings(state, settings) {
      state.accountSettings = settings;
    }
  },
  actions: {
    getCurrentAccountsSettings({ commit, rootGetters }) {
      commit('setSettingsLoaded', false);
      return new Promise((resolve, reject) => {
        axios.get(`${apiBase}/instagramaccount/${rootGetters.profileGuid}/settings`)
          .then((response) => {
            if (!response.data || response.status !== 200) {
              reject(response);
            }

            commit('getCurrentAccountsSettings', response.data);
            commit('setSettingsLoaded', true);
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateCurrentAccountsSettings({ commit, state, rootGetters }) {
      commit('showModal', 'LoadingModal');
      const instagramAccountId = rootGetters.profileGuid;
      return new Promise((resolve, reject) => {
        axios.put(`${apiBase}/instagramaccount/settings`, {
          instagramAccountId,
          ...state.accountSettings
        })
          .then((response) => {
            if (response.status !== 200) {
              reject(response);
              return;
            }

            commit('updateCurrentAccountsSettings', response.data);
            commit('hideModal');
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};
